// Every key this app writes to localStorage. Kept in one place so logout and the
// 401 handler clear the same set - previously only rrc_token/rrc_user were
// cleared, leaving the UPI id, applied coupon and guest session data behind on
// shared devices.
export const STORAGE_KEYS = {
  token: 'rrc_token',
  user: 'rrc_user',
  guestCart: 'rrc_guest_cart',
  guestWishlist: 'rrc_guest_wishlist',
  upiId: 'rrc_upi_id',
  appliedCoupon: 'rrc_applied_coupon',
  recentSearches: 'rrc_recent_searches',
};

// Cleared when a session ends. The guest cart/wishlist/search history are
// deliberately excluded: they belong to the browser, not the user, and the
// cart slice needs them to merge into the account on the next login.
const SESSION_KEYS = [
  STORAGE_KEYS.token,
  STORAGE_KEYS.user,
  STORAGE_KEYS.upiId,
  STORAGE_KEYS.appliedCoupon,
];

export const clearSession = () => {
  SESSION_KEYS.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch {
      /* storage unavailable (private mode) - nothing to clear */
    }
  });
};